import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./../App.css";
import { Button, Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

import { v4 as uuid } from "uuid";
import { FormContext } from "../context/FormContext";
import { ToolContext } from "../context/ToolContext";
import * as statusConstants from "../constants/status";
import * as linkBoxConstants from "../constants/linkBox";
import { updateGroupedConnection, findGroupedConnection } from "../app/networkSlice";
import LinkBoxConnectivityConfigurator from "./LinkBoxConnectivityConfigurator";

const LinkBoxSelector = () => {
  const { toolState } = useContext(ToolContext);
  const { formState, dispatch } = useContext(FormContext);
  const { clickedAsset } = toolState;
  const dispatchRedux = useDispatch();

  const reduxGroupedConnection = useSelector((state) => {
    return clickedAsset?.id ? findGroupedConnection(state, clickedAsset.id) : null;
  });

  const activeGroupedConnection = reduxGroupedConnection || formState.groupedConnectionProperties;
  const linkBox = activeGroupedConnection?.linkBox;
  const clientSettings = formState.clientSettings;

  const selectList = [{ name: linkBoxConstants.TWOWAY }, { name: linkBoxConstants.FOURWAY }];

  const updateNumberOfWays = (e) => {
    const value = e.target.value;

    let connectivity = {};

    if (clientSettings.features.ConfigurableLinkBoxEnabled) {
      connectivity = {
        closed: [],
      };
    }

    const newValue = {
      ...linkBox,
      numberOfWays: value,
      twoWayConnectivityIsClosed: false,
      connectivity: connectivity,
    };
    updateNode(newValue);
  };

  const updateStatus = (e) => {
    const value = e.target.value;

    const newValue = { ...linkBox, status: value };
    updateNode(newValue);
  };

  const addOrRemoveLinkedBox = (e) => {
    e.preventDefault();
    if (linkBox) {
      updateNode(null);
      return;
    }

    const formData = new FormData(e.target);
    const newValue = {
      id: uuid(),
      numberOfWays: formData.get("numberOfWays"),
      status: statusConstants.NEW,
    };

    updateNode(newValue);
  };

  const updateNode = (value) => {
    dispatch({
      form: "groupedConnectionProperties",
      field: "linkBox",
      value: value,
      type: "UPDATE_FIELD",
    });

    if (clickedAsset?.id) {
      dispatchRedux(
        updateGroupedConnection({
          id: clickedAsset.id,
          name: "linkBox",
          value,
        }),
      );
    }
  };

  const updateConnectivity = (e) => {
    if (!clientSettings.features.ConfigurableLinkBoxEnabled) {
      return;
    }

    const isClosed = e.target.value === linkBoxConstants.CLOSED;

    const newValue = { ...linkBox, twoWayConnectivityIsClosed: isClosed };
    updateNode(newValue);
  };

  return (
    <div
      className="bg-white-alpha"
      style={{
        padding: ".75rem",
        margin: ".75rem 0",
        marginBottom: "1rem",
      }}
    >
      <h6
        className="text-light"
        style={{
          fontSize: ".75rem",
          textTransform: "uppercase",
          fontWeight: 200,
        }}
      >
        Add Link Box
      </h6>
      <form onSubmit={addOrRemoveLinkedBox}>
        <div className="text-light d-flex">
          <Input
            type="select"
            name="numberOfWays"
            className="w-100"
            value={linkBox?.numberOfWays}
            onChange={updateNumberOfWays}
          >
            {selectList.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ))}
          </Input>

          <Button size="sm" color={linkBox ? "danger" : "success"} className="ml-2">
            <FontAwesomeIcon icon={linkBox ? faMinus : faPlus} />
          </Button>
        </div>
        <div>
          {linkBox && (
            <>
              <div className="pt-2">
                <Label for="status">New / Existing / Replacement</Label>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  value={linkBox?.status}
                  onChange={updateStatus}
                >
                  <option value={statusConstants.NEW}>New</option>
                  <option value={statusConstants.EXISTING}>Existing</option>
                  <option value={statusConstants.REPLACEMENT}>Replacement</option>
                </Input>
              </div>
              {clientSettings.features.ConfigurableLinkBoxEnabled &&
                linkBox.numberOfWays === linkBoxConstants.TWOWAY && (
                  <div className="pt-2">
                    <Label for="connectivity">Connectivity</Label>
                    <Input
                      type="select"
                      name="connectivity"
                      id="connectivity"
                      value={
                        linkBox?.twoWayConnectivityIsClosed === true
                          ? linkBoxConstants.CLOSED
                          : linkBoxConstants.OPEN
                      }
                      onChange={updateConnectivity}
                    >
                      <option value={linkBoxConstants.OPEN}>Open</option>
                      <option value={linkBoxConstants.CLOSED}>Closed</option>
                    </Input>
                  </div>
                )}

              {clientSettings.features.ConfigurableLinkBoxEnabled &&
                linkBox.numberOfWays === linkBoxConstants.FOURWAY && (
                  <>
                    <Label className="pt-2">Connectivity</Label>

                    <LinkBoxConnectivityConfigurator
                      clickedAsset={clickedAsset}
                      linkBox={linkBox}
                      updateNode={updateNode}
                    />
                  </>
                )}
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default LinkBoxSelector;
